export const prepareGradeSeoTitle = (prefix: string, item: string, parent: string) => {
  if (prefix === 'مقطع') return '';

  return `${parent && `${parent} `}${prefix && `${prefix} `}${item}`;
};
